import script from "./AnswerResultPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnswerResultPage.vue?vue&type=script&setup=true&lang=ts"

import "./AnswerResultPage.vue?vue&type=style&index=0&id=1dbb7c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbb7c6c"]])

export default __exports__